import React, { useCallback, useContext, useMemo } from 'react';
import { MenuItem } from '@mui/material';

import PodContext from '../../../../context/PodContext/PodContext';
import UserContext from '../../../../context/UserContext';
import { ALL_CLIENTS } from '../../../../context/PodContext/constants';
import { useCoachConfig } from '../../../hooks/useCoachConfig';

import texts from './texts.json';
import {
  StyledFormControl,
  StyledSelect,
} from './styles';

const ALL_CLIENTS_OPTION = { id: ALL_CLIENTS, name: texts.allClients };

const PodSelector = () => {
  const {
    pods,
    selectedPodId,
    updateSelectedPodId,
    isReady,
  } = useContext(PodContext);
  const { userId: coachId } = useContext(UserContext);
  const { coachConfig, loading: configLoading } = useCoachConfig(coachId);

  const podOptionsData = useMemo(() => {
    if (!pods?.length) return [ALL_CLIENTS_OPTION];
    return [ALL_CLIENTS_OPTION, ...pods];
  }, [pods]);

  const handlePodChange = useCallback((e) => {
    const newPodId = e.target.value;
    updateSelectedPodId(newPodId === ALL_CLIENTS ? null : newPodId);
  }, [updateSelectedPodId]);

  if (!isReady || configLoading || !coachConfig?.isPodEnabled) {
    return null;
  }

  return (
    <StyledFormControl size="small">
      <StyledSelect
        value={selectedPodId || ALL_CLIENTS}
        onChange={handlePodChange}
      >
        {podOptionsData.map((pod) => (
          <MenuItem key={pod.id} value={pod.id}>
            {pod.name}
          </MenuItem>
        ))}
      </StyledSelect>
    </StyledFormControl>
  );
};

export default PodSelector;
